/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_ecocheck.js                                                                                */
/**********************************************************************************************************************/
/* Controller.EcoCheck */

/**
 * @class this.Controller.Ecocheck
 */
(function() {
  var hfsEcoCheckController = {
    /**
     * opens/initializes the ecocheck overlay/webview
     *
     * @method openEcoCheck
     * @param {Object} options - options for opening / initializing the EcoCheck
     * @param {string} [options.type] - sets the type for the EcoCheck view, can be unset or "webview"
     * @param {string} [options.ctxRecon] - optional to pass a specific Reconstruction context on which the EcoCheck View will be based on
     * @returns void
     */
    openEcoCheck: function (options) {
      var _me = this;
      var isWebView = false;
      if (options !== undefined && options.type == 'webview') {
        isWebView = true;
      }
      this.Controller.ecocheck.isWebView = isWebView;

      if (isWebView) {
        var result = {
            dep: {name: ""},  // In the webview the location data of departure & arrival will be filled later
            arr: {name: ""}
        };
        if(options.ctxRecon){
          var recon = options.ctxRecon;
        }else {
          var recon = WebViewInterface.getReconstructionKey();
        }
      } else {
        var result = this.Controller.TP.instance.getAllResults();
        var recon = this.Controller.TP.selectedConnection.recon.ctx;
      }

      // Ecocheck Instanz wird angelegt
      this.Controller.ecocheck.ecoCheckInstance = Hafas.Core.newType("hafasEcoCheck", {
        ctxRecon: recon
      });
      this.Controller.ecocheck.ecoCheckInstance.init();

      // Loading ankündigen
      Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_Loading'));

      var model = {
        query: {
          dep: result.dep,
          arr: result.arr,
        },
        hideFavorites: true,
        isWebView: isWebView
      };

      // Overlay anzeigen
      if (!isWebView) {
        Hafas.Modules.Loader.loadTemplateFiles(['ecocheck.result.html'], Hafas.bind(function () {
          this.Controller.ecocheck.ecoCheckOverlay = Hafas.Core.newType("HafasOverlay", {
            app: _me,
            cssClass: 'lyr_ecoCheckOverlay',
            title: Hafas.Modules.i18n.get('EcoCheck.result.t_N_Headline'),
            outputHTML: Hafas.Modules.Render.renderTemplate("EcoCheck_Result", model),
            onClose: function () {
              Hafas.bind(this.Controller.ecocheck.closePopupHint, this)();
            }.bind(this),
            callback: function () {
            }
          });
        }, this));
      } else {
        Hafas('#HFS_Webview', false).innerHTML = Hafas.Modules.Render.renderTemplate("EcoCheck_Result", model);
      }
    },
    /**
     * re-renders the EcoCheck Content View
     *
     * @method reRenderView
     */
    reRenderView: function () {
      // Daten aus Inputfeld "Anzahl Fahrten" auslesen und an der Instanz setzen
      var amountValue = 1;
      var amountCommuteInputField = Hafas('#HFS_EcoCheckAmountCommute', false);
      var amountJnysInputFieldValue = amountCommuteInputField.value;
      var parsedInputValue = parseInt(amountJnysInputFieldValue);
      if (isNaN(parsedInputValue) || parsedInputValue == 0) {
        amountCommuteInputField.value = amountValue;
      } else {
        amountValue = parseInt(amountJnysInputFieldValue);
        amountCommuteInputField.value = amountValue;
      }
      this.Controller.ecocheck.ecoCheckInstance.setAmountJourneys(amountValue);

      // Datenmodell neu berechnen
      var result = this.Controller.ecocheck.ecoCheckInstance.getResult();
      var processedData = Hafas.bind(this.Controller.ecocheck.prepareDataForOutput, this)(result);
      Hafas.bind(this.Controller.ecocheck.renderView,this)(processedData);
    },
    /**
     * renders the EcoCheck Content View
     *
     * @method renderView
     * @params {object} processedData - Processed HCI result data
     */
    renderView: function (processedData) {
      var model = {
        result: processedData
      };
      Hafas.Modules.Render.render({
        file: 'ecocheck.result.html',
        target: 'HFS_EcoCheckResultWrapper',
        template: 'EcoCheck_ResultTable',
        model: model
      }, Hafas.bind(function (html) {
        var headerModel = {
          query:{
            dep: processedData.depLoc,
            arr: processedData.arrLoc
          },
          hideFavorites: true
        }
        if(this.Controller.ecocheck.isWebView) {
          Hafas('#HFS_EcoCheckHeader', false).innerHTML = Hafas.Modules.Render.renderTemplate("EcoCheck_ConnectionHeader", headerModel);
          Hafas.Util.gui.setVisibility(Hafas('#HFS_EcoCheckHeader', false),true);
        }
      }, this));
    },
    /**
     * Going through the processed HCI Data, this function will prepare everything for the rendering model (units, text labels, etc.)
     *
     * @method prepareDataForOutput
     * @params {object} data - Processed HCI result data
     * @returns {object} processedData - Updated processed data object
     */
    prepareDataForOutput: function (data) {
      var processedData = Hafas.Core.clone(data);
      var amountJourneys = this.Controller.ecocheck.ecoCheckInstance.getAmountJourneys();
      // Header
      for (var h = 0; h < processedData.header.length; h++) {
        var tmpHeader = processedData.header[h];
        if (h == 0) {
          tmpHeader.label = Hafas.Modules.i18n.get('EcoCheck.result.t_N_YourJourney');
          tmpHeader.selected = true;
        } else {
          tmpHeader.label = Hafas.Modules.i18n.get('EcoCheck.result.t_N_ColumnHeader_' + tmpHeader.type);
        }
      }
      for (var p = 0; p < processedData.tableData.length; p++) {
        var currentDataSet = processedData.tableData[p];
        currentDataSet.label = Hafas.Modules.i18n.get('EcoCheck.result.t_N_Row_' + currentDataSet.row);
        // Get the weight unit from config
        for (var v = 0; v < currentDataSet.values.length; v++) {
          var currentValue = currentDataSet.values[v].value;
          if(currentValue !== undefined) {
            if (currentDataSet.row == 'totalPrice') {
              if (currentValue !== undefined) {
                currentValue.amount *= amountJourneys;
              }
            } else {
              currentValue *= amountJourneys;
            }
            if (currentDataSet.row == 'co2') {
              // Round after two decimal places for CO2 values to align with display in connection overview
              currentValue = Math.round(currentValue * 100) / 100;

              var co2Weight = Hafas.Util.convertWeight(currentValue, "kg")
              currentValue =  co2Weight.weight + " " + co2Weight.unit;
            } else if (currentDataSet.row == 'nox' || currentDataSet.row == 'part10') {
              var miscWeight = Hafas.Util.convertWeight(currentValue, "g")
              currentValue =  miscWeight.weight + " " + miscWeight.unit;
            }
            currentDataSet.values[v].value = currentValue;
          }else{
            currentDataSet.values[v].value = "-";
          }
        }
      }
      return processedData;
    },
    /**
     * Updating the result table view
     *
     * @method updateResultTable
     * @params {object} data - Processed HCI result data
     */
    updateResultTable: function (data) {
      var processedData = Hafas.bind(this.Controller.ecocheck.prepareDataForOutput, this)(data);
      Hafas.bind(this.Controller.ecocheck.renderView,this)(processedData);
      Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));
    },
    /**
     * Opens a small info popup on the price column (which is disabled in the standard by default)
     *
     * @method openInfoPopup
     * @params {HTMLElement} domElem - HTML Element which serves as an anchor for the popup info hint
     * @params {String} type - References a type for the hint. e.g "price"
     */
    openInfoPopup: function (domElem, type) {
      var text = Hafas.Modules.i18n.get('EcoCheck.result.t_N_Hint_' + type);
      Hafas.bind(this.Controller.ecocheck.closePopupHint, this)();

      this.Controller.ecocheck.openInfoPopup = Hafas.Core.newType("HafasOverlay", {
        app: this,
        closeButton: false,
        cssClass: 'lyr_ecoCheckHint',
        anchoredOverlay: 'BOTH',
        anchorElement: domElem,
        outputHTML: Hafas.Modules.Render.renderTemplate("EcoCheck_InfoPopup", {label: text}),
        onClose: function () {

        }.bind(this),
        callback: function (html, err) {

        }
      });
    },
    /**
     * Closes a small info popup on the price column (which is disabled in the standard by default)
     *
     * @method closePopupHint
     */
    closePopupHint: function () {
      if (!this.Controller.ecocheck.openInfoPopup) {
        this.Controller.ecocheck.openInfoPopup.close();
      }
    },
    /**
     * Shows an error message in the EcoCheck view
     *
     * @method showError
     * @params {object} data - Processed HCI result data
     */
    showError: function (data) {
      Hafas('#HFS_EcoCheckMain', false).innerHTML = Hafas.Modules.Render.renderTemplate("EcoCheck_ErrorMsg", data);
    },
    /**
     * closes the infopopup view
     *
     * @method close
     */
    close: function () {
      this.Controller.ecocheck.ecoCheckOverlay.close();
      delete this.Controller.ecocheck.ecoCheckOverlay;
    }
  }
  if(typeof HafasWebapp !== "undefined" && typeof HafasWebapp.prototype.Controller !== "undefined") {
    HafasWebapp.prototype.Controller.ecocheck = hfsEcoCheckController;
  }else{
    HafasWebview.prototype.Controller.ecocheck = hfsEcoCheckController;
  }
}());

